;(function (window, document) {

	'use strict'

	function addHoursToDate(date, hours) {
		return new Date(new Date(date).setHours(date.getHours() + hours));
	}

	function dateToString(date) {
		return date.toISOString().replace(/[^0-9]/g, "");
	}

	function memoryInit() {

		// remember header advert actions
		let headerAdvert = document.getElementById('header-marketing');
		if ( headerAdvert ) {

			let headerAdvertCloseExpires = localStorage.getItem('header_advert_close_expires');
			let now = new Date();

			// check if we have an expiration date or if the date has passed
			if ( ! headerAdvertCloseExpires || dateToString(now) > headerAdvertCloseExpires ) {
				headerAdvert.style.display = '';
			}

			let headerAdvertClose = document.getElementById('header-marketing-close');
			headerAdvertClose.addEventListener('click', function (event) {
				headerAdvert.style.display = 'none';
				localStorage.setItem('header_advert_close_expires', dateToString(addHoursToDate(now, 6)));
			});
		}
	}

	// Start Animations when the page is ready.
	window.addEventListener('DOMContentLoaded', () => {
		memoryInit();
	})

})(window, document)